module.exports = "pegasus_template/assets/circle-pinterest.gif";